export const EAGER_NAMESPACES = ['common', 'navigation'] as const

export const LAZY_NAMESPACES = [
  'login',
  'reset-password',
  'confirm-account',
  'dashboard',
  'finalizers-dashboard',
  'processing',
  'reports',
  'block-order',
  'shipments',
  'returns',
  'notifications',
  'profile',
  'settings',
  'auth-common',
] as const

export const ALL_NAMESPACES = [...EAGER_NAMESPACES, ...LAZY_NAMESPACES] as const

export const DEFAULT_NAMESPACE = 'common' as const

export type EagerNamespace = (typeof EAGER_NAMESPACES)[number]
export type LazyNamespace = (typeof LAZY_NAMESPACES)[number]
export type AppNamespace = (typeof ALL_NAMESPACES)[number]
